import { render, staticRenderFns } from "./loan-history.vue?vue&type=template&id=73845fed&scoped=true&lang=pug"
import script from "./loan-history.vue?vue&type=script&lang=js"
export * from "./loan-history.vue?vue&type=script&lang=js"
import style0 from "./loan-history.vue?vue&type=style&index=0&id=73845fed&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73845fed",
  null
  
)

export default component.exports